import { ECategory } from '../../repositories/offers-comparison/v2/add-offer-to-comparison';

export function isOfferCategory(category: string | null): category is ECategory {
  return Object.values(ECategory).includes(category as ECategory);
}
